module.exports = __webpack_public_path__ + "static/media/HindVadodara-Light.8d13fbbb.woff2";